import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Header,
  Select,
  Tabs,
} from "@cloudscape-design/components";
import UsersAndRolesTab from "./UsersAndRolesTab";
import RoleDefinitionsTab from "./RoleDefinitionsTab";
import { usePermission } from "../../hooks/usePermission";
import { RootState } from "../../redux/reducers/rootReducer";
import { getPermissionConstantsRequest, getPermissionScopeOptionsRequest } from "../../redux/actions/permissionActions";
import { SYSTEM } from "./constants";
import "./PermissionManagement.css";

const PermissionManagement: React.FC = () => {
  const dispatch = useDispatch();
  const [activeTabId, setActiveTabId] = useState("users-roles");
  const [selectedSystem, setSelectedSystem] = useState<any>({ label: SYSTEM, value: SYSTEM });
  const { hasPermission } = usePermission();
  const meData = useSelector((state: RootState) => state.permission.me.data);
  const constantsData = useSelector((state: RootState) => state.permission.constants.data);

  const isSystemAdmin = !!meData?.is_system_admin?.[SYSTEM];

  useEffect(() => {
    dispatch(getPermissionScopeOptionsRequest());
    dispatch(getPermissionConstantsRequest({
      categories: ["system", "feature_actions", "factory_operations"],
      system: [SYSTEM],
    }));
  }, [dispatch]);

  const systemOptions = useMemo(() => {
    if (constantsData?.systems) {
      return constantsData.systems.map((s) => ({ label: s, value: s }));
    }
    return [{ label: SYSTEM, value: SYSTEM }];
  }, [constantsData]);

  const canSeeUsersRoles = hasPermission("permission_management.pm_view_users_roles");
  const canSeeRoleDefinitions = hasPermission("permission_management.pm_view_roles_definitions");

  const effectiveSystem = selectedSystem?.value || SYSTEM;

  const tabs = [
    ...(canSeeUsersRoles ? [{
      id: "users-roles",
      label: "Users & Roles",
      content: <UsersAndRolesTab selectedSystem={effectiveSystem} />,
      "data-testid": "tab-users-roles",
    }] : []),
    ...(canSeeRoleDefinitions ? [{
      id: "role-definitions",
      label: "Role Definitions",
      content: <RoleDefinitionsTab selectedSystem={effectiveSystem} />,
      "data-testid": "tab-role-definitions",
    }] : []),
  ];

  return (
    <div className="permission-management" data-testid="permission-management-page">
      <div className="permission-header">
        <div className="permission-header-row">
          <Header
            variant="h1"
            description="Users & Roles: assign roles and data scope to users. Role Definitions: define roles and configure feature-level permissions."
          >
            Permission Management
          </Header>
          {/* {isSystemAdmin && (
            <div className="view-as-floating">
              <span className="view-as-label">System:</span>
              <Select
                selectedOption={selectedSystem}
                onChange={({ detail }) => setSelectedSystem(detail.selectedOption)}
                options={[
                  { label: "All Systems", value: "All" },
                  ...systemOptions,
                ]}
                placeholder="System"
              />
            </div>
          )} */}
        </div>
      </div>

      <div className="permission-tabs-container">
        <Tabs
          data-testid="permission-tabs"
          activeTabId={activeTabId}
          onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
          tabs={tabs}
        />
      </div>
    </div>
  );
};

export default PermissionManagement;
